import { useState } from "react";
import { useTranslate } from "@refinedev/core";
import { LightningIcon } from "@phosphor-icons/react";
import { Button } from "@libertify/ui";
import PricingModal from "pages/subscription/components/PricingModal/";
import { useGetActiveSubscriptions } from "pages/pricing/hooks/useGetActiveSubscriptions/";
import { AnalyticsEvents } from "types/analytics/";
import { useAnalytics } from "hooks/useAnalytics/";

interface UpgradeButtonProps {
  iconOnly?: boolean;
  buttonLocation?: string;
}

export const UpgradeButton = ({
  iconOnly = false,
  buttonLocation,
}: UpgradeButtonProps) => {
  const t = useTranslate();
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  const { isFreeUser } = useGetActiveSubscriptions();
  const { trackEvent } = useAnalytics();

  if (!isFreeUser) return null;

  const handleClick = (_e: React.MouseEvent<HTMLButtonElement>) => {
    trackEvent(AnalyticsEvents.UpgradeButtonClick, {
      location: buttonLocation,
    });
    setIsPricingModalOpen(true);
  };

  return (
    <>
      {iconOnly ? (
        <Button
          variant="upgrade"
          size="m"
          onClick={handleClick}
          style={{ minWidth: "auto", padding: "8px" }}
        >
          <LightningIcon size={20} />
        </Button>
      ) : (
        <Button
          variant="upgrade"
          size="m"
          leftIcon={<LightningIcon />}
          onClick={handleClick}
          style={{ width: "100%", fontWeight: 400 }}
        >
          {t("buttons.upgradeToPro", "Upgrade to Pro")}
        </Button>
      )}
      <PricingModal
        open={isPricingModalOpen}
        onClose={() => setIsPricingModalOpen(false)}
      />
    </>
  );
};
